import { TIERS } from '@backrs_ui/common-ui/src/models/careerPath';
var SCORECARD_LEVELS = {
    advanced: 'Advanced',
    proficient: 'Proficient',
    notYet: 'Not Yet',
};
export var appStrings = {
    modules: {
        actionTabs: {
            bookmark: 'Bookmark',
            share: 'Share',
            task: 'Task',
        },
        toolTypes: {
            tool: 'Tool',
            guide: 'Guide',
            discovery: 'Discovery',
            'solution-session': 'Solution Session',
            assessment: 'Assessment',
        },
        educationalInvestment: {
            educationalInvestment: 'Educational Investment',
            toSucceed: 'To Succeed:',
        },
        questionnaire: {
            facet: 'Facet',
        },
        backrsSidebar: {
            backrs: 'backrs',
            search: 'Search',
        },
        emulationChip: {
            label: 'Emulating',
        },
        comingSoon: {
            title: 'Page Coming Soon',
        },
        desktopOnlyNotice: {
            title: 'Not optimized for mobile',
            description: 'For the best experience, please take the Life-Readiness Assessment on a browser.',
            copyLink: 'Copy Link',
        },
        notFound404: {
            title: 'Page not Found',
            action: 'Go Home',
        },
        login: {
            dividerText: 'OR',
            phonePlaceholder: 'Enter your phone #',
            emailPlaceholder: 'Enter your email',
            passwordPlaceholder: 'Enter your password',
            forgotPassword: 'Forgot Password?',
            backrsLogoAlt: 'Backrs logo',
            getStartedPrompt: 'Log in or sign up to get started.',
            getStartedButton: 'sign up',
            forgotPasswordPrompt: 'Please enter your email address and we will send you a link to reset your password.',
            forgotPassowordButton: 'Send',
            forgotPasswordSuccess: 'If you have an account, you will receive an email to reset your password.',
            resetPassword: {
                title: 'Set new password',
                subtitle: 'Your new password must be different to previously used passwords.',
                passwordPlaceholder: 'Password',
                confirmPasswordPlaceholder: 'Confirm password',
                minLengthCheck: 'Must be at least 8 characters',
                submitButton: 'Reset password',
                backToLogin: 'Back to log in',
                error: {
                    passwordRequired: 'Password is required',
                    minLength: 'Must be at least 8 characters',
                    confirmRequired: 'Please confirm your password',
                    mustMatch: 'Passwords must match',
                    expiredLink: 'We couldn’t reset your password. The link may have expired — please try again.',
                    tryAgain: 'Something went wrong. Please try again later.',
                },
            },
            error: {
                invalidPhone: 'Please enter a valid phone number',
                invalidEmail: 'Please enter a valid email',
                emailRequired: 'Email is required',
                passwordRequired: 'Password is required',
                phoneRequired: 'Phone number is required',
                phoneEmailRequired: 'Phone number or email is required',
                login: {
                    userNameOrPassword: 'Log in failed: Invalid username or password',
                    phone: 'Log in failed: Invalid phone number',
                    genericError: 'An error occurred while logging in. Please try again or contact an administrator for assistance.',
                },
            },
            otp: {
                title: 'Check your text messages',
                sentCodeTo: 'We sent a verification code to',
                didntReceiveText: 'Didn’t receive the text?',
                clickToResend: 'Click to resend',
                logIn: 'Log In',
                resendCode: 'Enter your phone number to resend your verification code.',
                contactSupportPrompt: 'Still not working? ',
                contactSupportButton: 'Contact support.',
                backToLogin: 'Back to log in',
                verifyPhoneNumber: 'Verify phone number',
            },
            welcomeBack: 'Welcome back! Please enter your details.',
            dontHaveAccount: "Don't have an account?",
            signUp: 'Sign up',
            phoneTab: 'Phone',
            emailTab: 'Email',
            oauth: {
                signInWithGoogle: 'Sign in with Google',
            },
        },
        register: {
            title: 'Join the community',
            confirmAge: 'I certify that I am 14 years of age or older.',
            termsPrompt: 'By registering, I accept Backrs Terms & Conditions',
            termsButton: 'Backrs Terms & Conditions',
            firstNamePlaceholder: 'First Name',
            lastNamePlaceholder: 'Last Name',
            phonePlaceholder: 'Phone Number',
            emailPlaceholder: 'Email',
            passwordPlaceholder: 'Password',
            inviteCodePlaceholder: 'Invite Code (if applicable)',
            buttonLabel: 'Save & Continue',
            ageCertification: 'I certify that I am 14 years of age or older.',
            error: {
                invalidPhone: 'Please enter a valid phone number',
                invalidEmail: 'Please enter a valid email',
                firstNameRequired: 'First name is required',
                lastNameRequired: 'Last name is required',
                emailRequired: 'Email is required',
                phoneRequired: 'Phone number is required',
                passwordRequired: 'Password is required',
                login: {
                    userNameOrPassword: 'Log in failed: Invalid username or password',
                    phone: 'Log in failed: Invalid phone number',
                    genericError: 'An error occurred while logging in. Please try again or contact an administrator for assistance.',
                },
            },
        },
        charts: {
            returnOnInvestment: {
                average: 'Average',
                title: '15-Year ROI',
                explanationTitle: '15-Year ROI',
                whatItIs: {
                    title: 'What it is',
                    paragraphs: [
                        'The 15-Year ROI is what a student is ahead by, in dollars, 15 years after starting at this school. It adds up former students’ earnings over those years and subtracts what it cost to attend—net price plus the wages they gave up while enrolled.',
                        'Because it counts both the cost of attending and the earnings that follow, it reflects the trade-off a student actually makes rather than earnings alone.',
                    ],
                },
                whyItMatters: {
                    title: 'Why this matters',
                    paragraphs: [
                        'Fifteen years is far enough out that a degree has had time to pay off, and close enough in that most of the earnings behind it were measured rather than projected. By this point in a career, a stronger return usually means it is easier to:',
                    ],
                    bulletPoints: [
                        'Pay down student debt sooner',
                        'Build savings and emergency buffers',
                        'Qualify for housing or relocate for better opportunities',
                        'Begin investing earlier, when compounding matters most',
                    ],
                },
                howToInterpret: {
                    title: 'How to interpret 15-Year ROI',
                },
                modalCards: {
                    veryGoodROI: {
                        title: 'High',
                        chartChipLabel: 'High',
                        chipLabelPrefix: '15-Year ROI',
                        chipLabelThreshold: '≥ $400,000',
                        chipColor: 'Success/500',
                        iconName: 'Hurricane01',
                        cardDescription: [
                            {
                                text: 'Students are ahead by $400,000 or more by year 15. Cost is usually recovered by year 10—about five years after finishing—and most of this figure is return built on top of that.',
                                bold: false,
                            },
                        ],
                    },
                    goodROI: {
                        title: 'Medium',
                        chartChipLabel: 'Medium',
                        chipLabelPrefix: '15-Year ROI',
                        chipLabelThreshold: '$200,000–$399,999',
                        chipColor: 'Warning/500',
                        iconName: 'Hurricane04',
                        cardDescription: [
                            {
                                text: 'Students are ahead by between $200,000 and $400,000 by year 15. Cost is usually recovered around year 10 or 11, and the return keeps building afterward.',
                                bold: false,
                            },
                        ],
                    },
                    lowROI: {
                        title: 'Low',
                        chartChipLabel: 'Low',
                        chipLabelPrefix: '15-Year ROI',
                        chipLabelThreshold: '< $200,000',
                        chipColor: 'Error/400',
                        iconName: 'Hurricane05',
                        cardDescription: [
                            {
                                text: 'Students come out ahead by year 15, but by less than $200,000, and cost usually takes until about year 12 to recover. Cost drives this as much as earnings: a high net price can put a school here even when its graduates earn well.',
                                bold: false,
                            },
                        ],
                    },
                },
                roiHorizonModal: {
                    title: 'Understanding ROI Horizon',
                    whatItIs: {
                        title: 'What it is',
                        paragraphs: [
                            'The ROI Horizon shows the long-term financial return of attending this school—where ROI (return on investment) means how much former students earn over time, minus what it cost them to attend and the wages they gave up while enrolled. The chart tracks that return 10, 15, 20, 30, and 40 years after enrollment, with each point shown as a real dollar amount. Together, the line shows how quickly the school tends to pay off and how strongly its value compounds across a career.',
                            'The shaded band is the typical range—the middle half of four-year colleges at each point on the chart—so you can see where this school sits against most others.',
                        ],
                    },
                    whyItMatters: {
                        title: 'Why it matters',
                        paragraphs: [
                            'The timing of ROI matters just as much as the total amount. Schools with higher ROI earlier in life tend to give graduates more financial flexibility when it counts most—during their 20s and 30s. Strong early returns can make it easier to:',
                        ],
                        bulletPoints: [
                            'Buy a home or qualify for a mortgage',
                            'Pay down debt and start investing earlier',
                            'Build savings and emergency buffers',
                            'Afford major life experiences like travel, starting a family, or launching a business',
                            'Begin saving for retirement while compounding is on your side',
                        ],
                        additionalParagraph: 'Later-life gains matter too, but early financial momentum often shapes long-term stability, optionality, and stress levels. The ROI Horizon helps you see whether a school supports not just long-run success, but real-life progress along the way.',
                    },
                    howItIsCalculated: {
                        title: 'How it is calculated',
                        paragraphs: [
                            "Backrs calculates these figures from the U.S. Department of Education's College Scorecard, which reports the median earnings of a school's former students—everyone who enrolled, not only graduates—in each of the years after they started.",
                            'In simple terms:',
                        ],
                        bulletPoints: [
                            'Earnings are added up year by year, using the years College Scorecard actually measures (years 6 through 11 after enrollment)',
                            'Later horizons carry year 11 earnings forward, so the further out the figure, the more of it is an estimate',
                            "Cost is the school's average net price—what students actually pay out of pocket—plus the wages a typical high school graduate earns, for each year a student is enrolled",
                            "Years enrolled reflect the credential: five years for a bachelor's degree, because four is longer than most students take. At the typical four-year college, about 40% of students finish within four years and 55% within six",
                            "These figures are published for colleges that mainly award bachelor's degrees; two-year and certificate schools have a different cost and earnings pattern and are not shown yet",
                            'Every dollar is adjusted to 2024 dollars so schools and years are comparable',
                            'A school is shown only when all of these inputs are reported for it',
                        ],
                        conclusion: 'The result is built on reported earnings and reported costs for former students of this school, not on national averages or projections of individual outcomes.',
                        source: 'Source: U.S. Department of Education, College Scorecard, including its high school graduate earnings threshold from the U.S. Census Bureau American Community Survey',
                    },
                },
                yAxisLabel: 'Cumulative Return',
                xAxisLabel: 'Year',
                legendLabel: 'Typical range for four-year colleges',
            },
            percentageBarChart: {
                minLabel: '0%',
                maxLabel: '100%',
            },
        },
        popoverFilterMenu: {
            clearAll: 'Clear All',
        },
        nugget: {
            eventSubtext: 'Date:',
            opportunitySubtext: 'Deadline:',
            dialogNuggetActions: {
                copyLink: 'Copy Link',
                linkCopied: 'Link copied!',
                markDone: 'Mark as done',
                markComplete: 'Mark complete',
                explainFitScore: 'Explain my fit score',
            },
            profile: {
                profile: 'Profile',
            },
            internship: {
                notAvailable: 'N/A',
                askLubav: {
                    amIAGoodFit: 'Am I a good fit?',
                    increaseMyOdds: 'Increase my odds',
                    similarRoles: 'Similar roles',
                },
                SECTION_TITLES: {
                    quickLook: 'Quick Look',
                    backrsAssessment: 'Backrs Assessment',
                    applicationLink: 'Application Link',
                },
                QUICK_LOOK: {
                    type: 'Type:',
                    path: 'Path:',
                    track: 'Track:',
                    location: 'Location:',
                    deadline: 'Deadline:',
                    industry: 'Industry:',
                },
                BACKRS_ASSESSMENT: {
                    growthPotential: 'Growth Potential:',
                    compensation: 'Compensation:',
                    intensity: 'Intensity:',
                    gpaRequirement: 'Real GPA required:',
                    achievementRequirement: 'Achievement required:',
                    experienceRequirement: 'Experience:',
                    technicalSkills: 'Technical skills:',
                },
            },
            scholarship: {
                SECTION_TITLES: {
                    awardRange: 'Award Range',
                    applicationDeadline: 'Application Deadline',
                    previousYear: 'Previous Year',
                    awardCategory: 'Award Category',
                    description: 'Description',
                    eligibilityRequirements: 'Eligibility Requirements & Program Restrictions',
                    howToApply: 'How to Apply',
                    applicationRequirements: 'Application Requirements',
                    applicationSubmission: 'Application Submission',
                    applicationDates: 'Application Dates',
                    applicationFee: 'Application Fee',
                    awardContact: 'Award Contact Information',
                },
                AWARD_INFO: {
                    AWARD_RANGE: 'Award Range:',
                    AWARD_TYPE: 'Award Type:',
                    APPLICATION_DEADLINE: 'Application Deadline:',
                    PREVIOUS_YEAR: 'Previous Year:',
                    AWARDS: 'awards',
                    AWARD_CATEGORY: 'Award Category:',
                    DESCRIPTION: 'Description:',
                },
                ELIGIBILITY_REQUIREMENTS_STRINGS: {
                    LEVEL_OF_STUDY_FRONT: 'Award for use during',
                    LEVEL_OF_STUDY_END: 'years of study',
                    INSTITUTION_TYPE: 'Students attending',
                    LIMITED_HS: 'High school students can apply',
                    TEST_SCORE: 'Test Score Requirement:',
                    AGE: 'Age:',
                    GENDER: 'Gender:',
                    MARITAL_STATUS: 'Marital Status:',
                    RACE_ETHNICITY: 'Race/Ethnicity:',
                    DISABILITY_TYPE: 'Disability Type:',
                    MILITARY_SERVICE: 'Military Service:',
                    SEPT_ELEVEN_RESTRICTION: '9/11 survivors/descendants',
                    HERITAGE: 'Heritage:',
                    CITIZENSHIP: 'Citizenship:',
                    RELIGIOUS_AFFILIATION: 'Denominations:',
                    TALENT: 'Talent:',
                    CLUB_MEMBERSHIP: 'Members of:',
                    AREA_OF_STUDY: 'Field of study:',
                    STATE_RESIDENCE: 'Residents of:',
                    STATE_USAGE: 'Usable in:',
                    COUNTY_RESIDENCE: 'County restrictions:',
                    INSTITUTION: 'Restricted to:',
                    CORP_AFFILIATION: 'Corporate affiliation:',
                    EMPLOYMENT: 'Employment:',
                },
                HOW_TO_APPLY_STRINGS: {
                    SUBMISSION_START: 'Submission Start Date:',
                    SUBMISSION_DEADLINE: 'Submission Deadline:',
                    CONTACT: 'Contact:',
                },
            },
            askLubav: {
                backrsProfile: 'Backrs profile',
                blueprint: 'Blueprint',
                networks: 'Networks',
                prosper: 'Prosper',
                errors: {
                    COMING_SOON: 'Coming soon!',
                    NOT_LOGGED_IN: 'You must be logged in to use this feature!',
                    RESUME_REQUIRED: 'To use this feature, please upload your resume to your ',
                    BLUEPRINT_REQUIRED: 'You must have completed a blueprint to use this feature. You can do so by navigating to ',
                    DEFAULT: "We're experiencing exceptionally high demand at the moment. Please check back in a few minutes! In the meantime, check out ",
                },
            },
            unlockCard: {
                fourUnlocks: 'Four Unlocks',
                opportunitiesToGrow: 'Opportunities to Grow',
                strengths: 'Strengths',
                strengthsAndOpportunities: 'Strengths & Opportunities',
                uploadYourTranscript: 'Upload your transcript',
            },
            careerPath: {
                suggestedFits: {
                    strong: 'Strong',
                    medium: 'Medium',
                    low: 'Low',
                },
                earlyCareerHires: 'Early-career hires per year',
                skilled: 'Skilled/Technical',
                professional: 'Professional',
                growth: 'Growth',
                ai_disruption: 'AI Disruption',
                insight: 'Insight',
                careerTrackDistribution: 'Career Track Distribution',
                semiSkilled: 'Semi-Skilled',
                tradesTechnical: 'Trades/Technical',
                middleTier: 'Middle-Tier Pro',
                upperTier: 'Upper-Tier Pro',
                topTier: 'Top-Tier Pro',
                opportunities: 'Opportunities',
                profiles: 'Profiles',
                employers: 'Employers',
                comingSoon: 'coming soon',
                threeRoles: function (careerPath) { return "3 ".concat(careerPath.toLowerCase(), " roles for me"); },
                compensationPotential: '$$ potential',
                requirements: 'How to succeed',
                aiDisruption: 'AI disruption',
                caregiverFlexibility: 'Caregiver flexibility',
                bestMajors: 'Top majors',
            },
            textResponseDaysAgo: 'days ago',
            coach: 'Coach',
        },
        deepDive: {
            card: {
                backrsLabel: 'Backrs',
                ctaLabel: 'Schedule a free intro call',
            },
        },
        headerCTA: {
            lifeReadiness: {
                title: 'How life ready are you?',
                buttonText: 'Take the assessment',
            },
        },
        assessMyTrack: {
            standardsByTrack: {
                title: 'Standards by Track',
                dimension: 'Dimension',
                track: 'Track',
                description: 'These are the minimum markers of progression for students by track, by asset, by tenure including early high school, graduating from high school, early post-secondary, and graduating from post-secondary education.',
            },
            criteriaText: {
                counts: 'Counts:',
                doesNotCount: "Doesn't count:",
            },
            scorecardLevels: SCORECARD_LEVELS,
            standardsByLevel: {
                title: 'Standards by Level',
                description: 'These are the markers of progression for each dimension at your current grade. Proficient is the bar to clear; Advanced is what it looks like to stand out.',
                levelLabels: {
                    Minimum: SCORECARD_LEVELS.proficient,
                    Advanced: SCORECARD_LEVELS.advanced,
                },
            },
            areYouOnTrackSummary: {
                title: 'Are you on track?',
                description: function (careerTrackName) {
                    return "Below you'll find key activities and milestones for a student in college that will ensure you get on and stay on at least the **".concat(careerTrackName, "** track.");
                },
                descriptionEmptyState: 'You know where you want to go, but are you on your way to get there? Learn how close you are to reaching your goals and aspirations.',
                learnMore: 'Check your progress',
                learnMoreMobile: 'Check progress',
                assessYourTrack: 'Assess Your Track',
                theFourUnlocks: 'The Four Unlocks',
                fullName: 'Name',
                yourStrengths: 'Your Strengths',
                opportunitiesToGrow: 'Opportunities',
            },
            careerTrackPlot: {
                learnMore: 'Learn more about tracks',
                compensationByMid40s: 'Compensation by Mid-40s',
                track: 'Track',
                salaryRanges: {
                    topTier: '> $400,000',
                    upperTier: '$250,000 - $400,000',
                    middleTier: '$50,000 - $150,000',
                    tradesTechnical: '$50,000 - $120,000',
                    semiSkilled: '$33,000 - $70,000',
                    unskilled: '< $35,000',
                },
                title: function (track) { return "You are currently on track to be, at maximum, ".concat(track, "."); },
                articleForTrack: function (track, type) {
                    switch (track) {
                        case TIERS.TOP:
                            return 'a';
                        case TIERS.UPPER:
                            return 'an';
                        case TIERS.MID:
                            return 'a';
                        case TIERS.TRADE:
                            return type === 'title' ? 'in' : 'a';
                        case TIERS.SEMISKILLED:
                            return type === 'title' ? '' : 'a';
                    }
                },
                highSchool: {
                    description: function (gpa, courseworkRigorLevel, track) { return ({
                        introBeforeTrack: 'You are currently on track to be, at max,',
                        track: "".concat(track.toLowerCase(), " professional"),
                        blueprintSentence: function (blueprintTrack) { return ({
                            beforeLink: ', while your',
                            linkText: 'Blueprint results',
                            afterLink: "indicate that your goal is ".concat(blueprintTrack.toLowerCase(), " professional."),
                        }); },
                        introPeriod: '.',
                        reason: "Your ".concat(courseworkRigorLevel.toLowerCase(), " rigorous coursework and ").concat(gpa, " GPA{testScores} have the biggest impact on your max track, as Academic Foundations are the most important factor. You can also strengthen your profile with other aspects of life-readiness, and it's best to start as soon as possible\u2014changing tracks gets harder with age."),
                    }); },
                },
                college: {
                    description: function (gpa, majorRigorLevel, schoolSelectivityLevel, track) { return ({
                        introBeforeTrack: 'You are currently on track to be, at max,',
                        track: "".concat(track.toLowerCase(), " professional"),
                        blueprintSentence: function (blueprintTrack) { return ({
                            beforeLink: ', while your',
                            linkText: 'Blueprint results',
                            afterLink: "indicate that your goal is ".concat(blueprintTrack.toLowerCase(), " professional."),
                        }); },
                        introPeriod: '.',
                        reason: "Your ".concat(majorRigorLevel.toLowerCase(), " major at a ").concat(schoolSelectivityLevel.toLowerCase(), " university and ").concat(gpa, " GPA{testScores} have the biggest impact on your max track, as Academic Foundations are the most important factor. You can also strengthen your profile with other aspects of life-readiness, and it's best to start as soon as possible\u2014changing tracks gets harder with age."),
                    }); },
                },
            },
        },
        profile: {
            editProfile: {
                fileUpload: {
                    uploading: 'Uploading...',
                    clickToUpload: 'Click to upload',
                    dragAndDrop: 'or drag and drop',
                    maxFileSize: function (maxFileSize) { return "max. ".concat(maxFileSize / 1024 / 1024, "MB"); },
                    acceptedFileTypes: function (fileTypes, additionalText) {
                        var types = fileTypes.map(function (type) { return type.toUpperCase(); });
                        if (types.length === 0)
                            return '';
                        if (types.length === 1)
                            return types[0];
                        if (types.length === 2)
                            return "".concat(types[0], " or ").concat(types[1]);
                        return "".concat(types.slice(0, -1).join(', '), " or ").concat(types.at(-1), " ").concat(additionalText ? "(".concat(additionalText, ")") : '');
                    },
                },
            },
        },
        audioRecording: {
            errors: {
                unsupported: 'Recording is not supported in this browser.',
                'permission-denied': 'Microphone access is blocked. Allow it for this site in your browser settings to record.',
                'no-microphone': 'No microphone was found. Connect one and try again.',
                'start-failed': "We couldn't start recording. Please try again.",
                'recording-failed': 'Recording stopped unexpectedly. Please try again.',
                'no-speech': "We didn't catch that. Try recording again.",
                'transcription-failed': "We couldn't transcribe that recording. Please try again.",
            },
        },
        lubav: {
            inputBox: {
                askLubav: 'Ask Lubav anything!',
                typeAMessage: 'Type a message...',
                send: 'Send',
                stop: 'Stop',
                fileValidationError: 'Only images, PDFs, and documents under 10MB are supported.',
                recordMessage: 'Record a message',
                stopRecording: 'Stop recording',
            },
            message: {
                you: 'You',
                cancel: 'Cancel',
                submit: 'Submit',
                moreContext: 'More context',
                lessContext: 'Less context',
            },
        },
        blueprint: {
            didYouKnow: 'Did you know?',
        },
        monthCalendar: {
            today: 'Today',
            previousMonth: 'Previous month',
            nextMonth: 'Next month',
            moreEntries: function (count) { return "+".concat(count, " more"); },
            dayAriaLabel: function (kindLabel, dayOfMonth, status, month) {
                return month
                    ? "".concat(kindLabel, " ").concat(month, " ").concat(dayOfMonth, ", ").concat(status)
                    : "".concat(kindLabel, " day ").concat(dayOfMonth, ", ").concat(status);
            },
        },
    },
    userMenu: {
        emulateAssignees: 'Emulate Assignees',
        exitEmulation: 'Exit Emulation',
    },
    assigneeEmulation: {
        searchPlaceholder: 'Search users to emulate...',
        emulateButton: 'Emulate User',
        emulateButtonLoading: 'Requesting...',
        noUsersFound: function (searchTerm) {
            return searchTerm ? "No users found for \"".concat(searchTerm, "\"") : 'No users found';
        },
        startTyping: 'Start typing to search for users to emulate',
        loadFailed: 'Failed to load users. Please try again.',
        emulationFailed: 'Failed to emulate user. Please try again.',
        loadingText: 'Loading...',
    },
    commandPalette: {
        noResultsFound: 'No results found',
        navigateHint: 'to navigate',
        selectHint: 'to select',
        closeHint: 'to close',
    },
    buttonText: {
        letsGo: "Let's go!",
        login: 'Log In',
        viewMore: 'View More +',
        viewLess: 'View Less -',
        signIn: 'Sign in',
        next: 'Next',
        previous: 'Previous',
        submit: 'Submit',
        finish: 'Finish',
        back: 'Back',
        readMore: 'Read More',
        readLess: 'Read Less',
        backToLifeReadiness: 'Back to Life Readiness',
    },
};
